"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidDurationHour = exports.SessionService = exports.SessionServiceEventType = exports.SessionEndReason = void 0;
const superstruct_1 = require("superstruct");
const Utils_1 = require("./Utils");
var SessionEndReason;
(function (SessionEndReason) {
    SessionEndReason["TIMEOUT"] = "SESSION_TIMEOUT";
})(SessionEndReason = exports.SessionEndReason || (exports.SessionEndReason = {}));
var SessionServiceEventType;
(function (SessionServiceEventType) {
    SessionServiceEventType["STARTED"] = "ADP_SESSION_STARTED";
    SessionServiceEventType["EXPIRED"] = "ADP_SESSION_EXPIRED";
})(SessionServiceEventType = exports.SessionServiceEventType || (exports.SessionServiceEventType = {}));
class SessionService {
    constructor(contextService, localDataService) {
        this.contextService = contextService;
        this.localDataService = localDataService;
        this.eventHub = new EventTarget();
    }
    get maxAgeMS() {
        return this.localDataService.sessionMaxAgeMS;
    }
    get trackTimestamp() {
        return this.localDataService.sessionStartedAt;
    }
    set trackTimestamp(value) {
        this.localDataService.sessionStartedAt = value;
    }
    get expired() {
        if (this.maxAgeMS <= 0 || this.localDataService.sessionLastActivity <= 0)
            return false;
        return this.localDataService.sessionLastActivity + this.maxAgeMS <= Date.now();
    }
    /** Alias for addEventListener. Syntax sugar for 'this' chaining */
    on(event, cb) {
        this.eventHub.addEventListener(event, cb);
        return this;
    }
    clearTimer() {
        clearTimeout(this.timer);
        this.timer = undefined;
    }
    /** Replaces timeout with remaining ttl */
    resetTimer() {
        this.clearTimer();
        this.timer = setTimeout(() => {
            if (!this.localDataService.sessionId)
                return;
            if (!this.expired) {
                this.resetTimer();
                return;
            }
            this.onSessionExpired();
        }, Math.max(0, this.maxAgeMS - (Date.now() - this.localDataService.sessionLastActivity)));
    }
    onSessionStart() {
        this.eventHub.dispatchEvent(new CustomEvent(SessionServiceEventType.STARTED, {
            detail: { id: this.localDataService.sessionId },
        }));
    }
    onSessionExpired() {
        var _a;
        if (this.localDataService.sessionId) {
            this.eventHub.dispatchEvent(new CustomEvent(SessionServiceEventType.EXPIRED, {
                detail: {
                    id: this.localDataService.sessionId,
                    reason: SessionEndReason.TIMEOUT,
                    sessionStartAt: (_a = this.trackTimestamp) !== null && _a !== void 0 ? _a : 0,
                },
            }));
        }
        this.localDataService.deleteSession();
        this.clearTimer();
    }
    startSession() {
        if (this.expired) {
            this.onSessionExpired();
        }
        const isAvailable = this.available;
        const { sessionId } = this.contextService.context.config;
        const initializedWithDifferentId = isAvailable && !!sessionId && this.localDataService.sessionId !== sessionId;
        if (!isAvailable || initializedWithDifferentId) {
            this.localDataService.sessionId = sessionId || (0, Utils_1.genGuid)();
            this.localDataService.sessionMaxAgeMS = this.contextService.context.config.sessionDuration.hour * 60 * 60 * 1000;
            this.localDataService.sessionLastActivity = Date.now();
            this.trackTimestamp = 0;
            this.onSessionStart();
        }
        this.contextService.session = this.localDataService.sessionId;
        this.resetTimer();
        return this;
    }
    refresh() {
        if (!this.available)
            return;
        this.localDataService.sessionLastActivity = Date.now();
        this.resetTimer();
    }
    get available() {
        return !!this.localDataService.sessionId && !this.expired;
    }
}
exports.SessionService = SessionService;
exports.ValidDurationHour = (0, superstruct_1.min)((0, superstruct_1.integer)(), 0);
